module.exports = __webpack_public_path__ + "img/SKMJ_etc1.3f1011ad.jpg";